if (!customElements.get('ss-project-list')) {
  customElements.define('ss-project-list', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-project-card]')];
      this.filter = this.querySelector('[data-project-filter]');
      this.more = this.querySelector('[data-project-more]');
      this.batchSize = Number(this.dataset.batchSize) || 12;
      this.visibleCount = this.batchSize;
      this.count = this.querySelector('[data-project-count]');
      this.countTemplate = this.count.textContent.replace(/\d+/, '{count}');
      const model = new URL(location.href).searchParams.get('modell');
      if ([...this.filter.options].some(o => o.value === model)) this.filter.value = model;
      this.filter.addEventListener('change', () => {
        this.visibleCount = this.batchSize;
        const url = new URL(location.href);
        if (this.filter.value) url.searchParams.set('modell', this.filter.value);
        else url.searchParams.delete('modell');
        history.replaceState(null, '', url);
        this.update();
      });
      this.more.addEventListener('click', () => {
        const oldCount = this.visibleCount;
        this.visibleCount += this.batchSize;
        this.update();
        this.matches[oldCount]?.querySelector('button, a')?.focus();
      });
      this.update();
      this.onHash = () => {
        const target = this.cards.find(c => '#' + c.id === location.hash);
        if (!target) return;
        this.filter.value = '';
        this.visibleCount = Math.max(this.batchSize, this.cards.indexOf(target) + 1);
        this.update();
        target.scrollIntoView({block:'start'});
      };
      window.addEventListener('hashchange', this.onHash);
      this.onHash();
    }
    update() {
      this.matches = this.cards.filter(c => !this.filter.value || c.dataset.model.split('|').includes(this.filter.value));
      const visible = new Set(this.matches.slice(0, this.visibleCount));
      this.cards.forEach(c => c.hidden = !visible.has(c));
      this.count.textContent = this.countTemplate.replace('{count}', this.matches.length);
      this.more.hidden = this.matches.length <= this.visibleCount;
    }
    disconnectedCallback() {
      if (this.onHash) window.removeEventListener('hashchange', this.onHash);
    }
  });
}
